import React from "react";
import styled from "styled-components";
import { ExternalLink } from "react-external-link";

const SocialCard = styled.div`
  height: fit-content;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  /*background: ${(props) => props.theme.colors.primary};*/
  padding: 20px 25px;
  border-radius: 14px;
`;

const Button = styled.button`
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background-color: transparent;
  position: relative;
  border-radius: 7px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover .BG {
    transform: scale(1.5);
    font-size: 20px;
    color: white;
  }

  &:hover .svgContainer {
    border: 1px solid rgba(216, 216, 216, 0.466);
    background-color: rgba(209, 209, 209, 0.466);
    backdrop-filter: blur(4px);
  }
`;

const SvgContainer = styled.span`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  backdrop-filter: blur(0px);
  letter-spacing: 0.8px;
  border-radius: 10px;
  transition: all 0.3s;
  border: 1px solid rgba(156, 156, 156, 0.466);
  z-index: 2;
  color: #fff;
`;

const Background = styled.span`
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
  border-radius: 10px;
  pointer-events: none;
  transition: all 0.3s;
  font-size: 0px;
  background: ${(props) => props.bgColor || "#181818"};
`;

const SocialButton = ({ children, bgColor }) => (
  <Button>
    <SvgContainer className="svgContainer">{children}</SvgContainer>
    <Background className="BG" bgColor={bgColor} />
  </Button>
);

const Socialmedia = ({ itemsMedia }) => {
  return (
    <SocialCard>
      {itemsMedia.map(({ url, icon, bgColor }) => {
        return (
          <ExternalLink className="pt-3" href={url}>
            <SocialButton bgColor={bgColor}>{icon}</SocialButton>
          </ExternalLink>
        );
      })}
    </SocialCard>
  );
};

export default Socialmedia;
